export default "__VITE_ASSET__60804604__"